import React, { useContext, useEffect, useState } from 'react';
import { Context_UI } from '../../Contexts/Context_UI';
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { useAuth } from '../../Contexts/AuthContext';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';

export default function Tab_ScheduleManagement_Timetable({ Schedules, Room, InitialView }) {
    const UI = useContext(Context_UI);
    const { Account } = useAuth();
    const { Panel_Right_State, Panel_Toggle } = useStatus();
    const { Schedule_Display, Time_Parse, Time_Range_Parse, Reservation_Set, Reservation_Default } = useScheduleManagement();

    // Filter schedules so only the chosen room is displayed
    const Events = Schedules
        .filter(s => !Room || s.RoomID === Room)
        .map(s => ({
            id: s._id,
            title: s.Name,
            start: s.Time.Start,
            end: s.Time.End,
            extendedProps: {
                RoomID: s.RoomID,
                Description: s.Description
            }
        }));

    const Handle_Click = async (Information) => {
        await Schedule_Display(Information.event._def.publicId);
        if (Panel_Right_State === "Collapsed") {
            Panel_Toggle("Right");
        }
    };



    const Handle_Select = async (Information) => {
        const Start = new Date(Information.start);
        const End = new Date(Information.end);
        Reservation_Set(Previous => ({
            ...Reservation_Default,
            RoomID: Room || "",
            Time: {
                Start: Start,
                End: End
            },
            DateCreated: new Date(),
            DateModified: new Date()
        }));
        UI.Subwindows_Open("Window_ScheduleManagement_Reserve");
    }

    return (
        <div className='SM_Timetable'>
            <FullCalendar
                plugins={[timeGridPlugin, interactionPlugin]}
                initialView={InitialView === "Week" ? "timeGridWeek" : "timeGridWeek"}
                headerToolbar={{
                    left: "title",
                    center: "",
                    right: "prev next today"
                }}
                allDaySlot={false}
                slotMinTime="04:30:00"
                slotMaxTime="24:00:00"
                selectable={true}
                editable={false}
                events={Events}
                height="auto"
                eventClick={Handle_Click}
                select={(Info) => Handle_Select(Info)}
            />
        </div>
    );
}
